export default __webpack_public_path__ + "static/blooming_desire_2-1ab0ff4ec6f72a28b672527b29d895e1.png";